export const PAYMENT_RESULT_TOKEN_QUERY_KEYS = ['payment_intent_id'] as const;
export const PAYMENT_RESULT_TOKEN_PATTERN =
  /^pi_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

type SearchParamRecord = Record<string, string | string[] | undefined>;
type QueryParamReader = Pick<URLSearchParams, 'getAll'>;

export function sanitizePaymentResultToken(value: string | null | undefined) {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  return PAYMENT_RESULT_TOKEN_PATTERN.test(trimmed) ? trimmed : null;
}

export function isPaymentResultToken(
  value: string | null | undefined
): value is string {
  return sanitizePaymentResultToken(value) !== null;
}

export function resolvePaymentResultTokenFromSearchRecord(
  searchParams: SearchParamRecord
): string | null {
  for (const key of PAYMENT_RESULT_TOKEN_QUERY_KEYS) {
    const rawValue = searchParams[key];
    const values = Array.isArray(rawValue) ? rawValue : [rawValue];
    for (const value of values) {
      const token = sanitizePaymentResultToken(value);
      if (token) {
        return token;
      }
    }
  }

  return null;
}

export function resolvePaymentResultTokenFromQueryReader(
  searchParams: QueryParamReader
): string | null {
  for (const key of PAYMENT_RESULT_TOKEN_QUERY_KEYS) {
    for (const value of searchParams.getAll(key)) {
      const token = sanitizePaymentResultToken(value);
      if (token) {
        return token;
      }
    }
  }

  return null;
}
